import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../../axios.js';
import moment from 'moment/moment';

import '../Resources/dashboard.css';
import Navbar from '../navbar';
import Sidebar from '../Sidebar';
import Add_product from './add_product';
import Add_productgroup from './add_productgroup';

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

//FOR QR CODE GENERATION
import { QRCodeCanvas } from "qrcode.react";
import Add_service from './add_service.js';

function Userservices(){

  
 //Report Print Function
 const componentRef = useref();
 const handlePrint = useReactToPrint({
   content: () => componentRef.current,
 });

 //Report Print Function 1
 const componentRef1 = useref();
 const handlePrint1 = useReactToPrint({
   content: () => componentRef1.current,
 });

 
 //QR Print Function
 const componentRef2 = useref();
 const handlePrint2 = useReactToPrint({
   content: () => componentRef2.current,
 });


 //Saving Values for QR Code Generator
 {/*} const [product, setProduct] = useState({
    product_code: "", product_name: "", quantity: "", rate: ""
  });

  const handleChange = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.value });
  }; */}

 //Variables
const[services,setservices] = useState([]);//SetData Variable

  // Function to download the data as an Excel file
  const downloadExcel = () => {
    // Convert JSON data to Excel worksheet
    const worksheet = XLSX.utils.json_to_sheet(services);
    
    // Create a new workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    
    // Convert the workbook to a binary array
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    
    // Create a Blob from the binary data and trigger a download
    const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(excel_data, "services_list.xlsx");
  };
  

  

 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");



 
 
{/* PRODUCTS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
const[cd_col12_val,setcd_col12_val] = useState(0);//column12
const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14
const[cd_col15_val,setcd_col15_val] = useState(0);//column15
const[cd_col16_val,setcd_col16_val] = useState(0);//column16
const[cd_col17_val,setcd_col17_val] = useState(0);//column17
const[cd_col18_val,setcd_col18_val] = useState(0);//column18
const[cd_col19_val,setcd_col19_val] = useState(0);//column19
const[cd_col20_val,setcd_col20_val] = useState(0);//column20
const[cd_col21_val,setcd_col21_val] = useState(0);//column21
const[cd_col22_val,setcd_col22_val] = useState(0);//column22
const[cd_col23_val,setcd_col23_val] = useState(0);//column23
const[cd_col24_val,setcd_col24_val] = useState(1);//column23


{/* PRODUCTS TABLE COLUMNS MANAGEMENT VARIABLES END */}


 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 {/*if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
  else*/}{

   

    
      


//Error Variable
const[errorvar,seterrorvar] = useState();



//FILTER VARIABLES
const[filter_val,setfilter_val] = useState(0);
const[filter_service_id,setfilter_service_id] = useState(); const updatefilter_service_id = (event) => { setfilter_service_id(event.target.service_id);}; const[filter_service_id_er,setfilter_service_id_er]=useState();
const[filter_service_code,setfilter_service_code] = useState(); const updatefilter_service_code = (event) => { setfilter_service_code(event.target.value);}; const[filter_service_code_er,setfilter_service_code_er]=useState();
const[filter_service_name,setfilter_service_name] = useState(); const updatefilter_service_name = (event) => { setfilter_service_name(event.target.value);}; const[filter_service_name_er,setfilter_service_name_er]=useState();
const[filter_type,setfilter_type] = useState(); const updatefilter_type = (event) => { setfilter_type(event.target.value);}; const[filter_type_er,setfilter_type_er]=useState();
const[filter_category,setfilter_category] = useState(); const updatefilter_category = (event) => { setfilter_category(event.target.value);}; const[filter_category_er,setfilter_category_er]=useState();
const[filter_sales_rate,setfilter_sales_rate] = useState(); const updatefilter_sales_rate = (event) => { setfilter_sales_rate(event.target.value);}; const[filter_sales_rate_er,setfilter_sales_rate_er]=useState();
const[filter_service_cost,setfilter_service_cost] = useState(); const updatefilter_service_cost = (event) => { setfilter_service_cost(event.target.value);}; const[filter_service_cost_er,setfilter_service_cost_er]=useState();
const[filter_service_status,setfilter_service_status] = useState(); const updatefilter_service_status = (event) => { setfilter_service_status(event.target.value);}; const[filter_service_status_er,setfilter_service_status_er]=useState();



//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();


//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);

useEffect(()=>{
   
  getData();
  
  },[])
 
    
  
//******************* GET PRODUCTS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((busyid!=null)||(busyid!=" "))){
 
    
    
  //Fetching Filter Variables
  const $filter_service_id = filter_service_id;const $filter_service_code = filter_service_code;const $filter_service_name = filter_service_name; const $filter_type = filter_type;const $filter_category = filter_category;
  const $filter_service_status = filter_service_status;const $filter_sales_rate = filter_sales_rate;const $filter_service_cost = filter_service_cost;
 
 axios.post("bt-get-services-default", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
  //Filters
  Filter_val : filter_val,
  Filter_service_id : $filter_service_id,
  Filter_service_code : $filter_service_code,
  Filter_service_name : $filter_service_name,
  Filter_type : $filter_type,
  Filter_category : $filter_category,
  Filter_sales_rate : $filter_sales_rate,
  Filter_service_cost : $filter_service_cost,
  Filter_service_status : $filter_service_status, 
 
//Code Edits for pagination
'page' : pageNumber
 })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
 //  setservices(response.data.services.data);
   // Setting Data
  const res = response.data.services;
  const serviceList = Array.isArray(res) ? res : res.data;  // ✅ handle both cases
  setservices(serviceList || []);
  
  }
     //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){
    setfilter_service_id_er(response.data.validatorerror.Filter_service_id);
    setfilter_service_code_er(response.data.validatorerror.Filter_service_code);
    setfilter_service_name_er(response.data.validatorerror.Filter_service_name);
    setfilter_type_er(response.data.validatorerror.Filter_type);
    setfilter_category_er(response.data.validatorerror.Filter_category);
    setfilter_sales_rate_er(response.data.validatorerror.Filter_sales_rate);
    setfilter_service_cost_er(response.data.validatorerror.Filter_service_cost);
    setfilter_service_status_er(response.data.validatorerror.Filter_service_status);

  }

  //Data Violation
  if(response.data.error==102){ 
  
    setfilter_service_id_er(response.data.filter_service_id_er);
    setfilter_service_code_er(response.data.filter_service_code_er);
    setfilter_service_name_er(response.data.filter_service_name_er);
    setfilter_type_er(response.data.filter_type_er);
    setfilter_category_er(response.data.filter_category_er);
    setfilter_sales_rate_er(response.data.filter_sales_rate_er);
    setfilter_service_cost_er(response.data.filter_service_cost_er);
    setfilter_service_status_er(response.data.filter_service_status_er);
   
  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* GET SERVICES DATA FUNCTION END  ********************//



 

 
 //******************* GET SERVICE ITEM DATA BY ID FUNCTION START  ********************//


//eservice_name
const[eservice_name,seteservice_name]=useState();const updateeservice_name = (event) => { seteservice_name(event.target.value);}; const[eservice_name_er,seteservice_name_er]=useState();
//eservice_code
const[eservice_code,seteservice_code]=useState();const updateeservice_code = (event) => { seteservice_code(event.target.value);}; const[eservice_code_er,seteservice_code_er]=useState();
//eservice_type
const[eservice_type,seteservice_type]=useState();const updateeservice_type = (event) => { seteservice_type(event.target.value);}; const[eservice_type_er,seteservice_type_er]=useState();
//eservice_category
const[eservice_category,seteservice_category]=useState();const updateeservice_category = (event) => { seteservice_category(event.target.value);}; const[eservice_category_er,seteservice_category_er]=useState();
//eservice_status
const[eservice_status,seteservice_status]=useState();const updateeservice_status = (event) => { seteservice_status(event.target.value);}; const[eservice_status_er,seteservice_status_er]=useState();
//edescription
const[edescription,setedescription]=useState();const updateedescription = (event) => { setedescription(event.target.value);}; const[edescription_er,setedescription_er]=useState();
//esales_rate
const[esales_rate,setesales_rate]=useState();const updateesales_rate = (event) => { setesales_rate(event.target.value);}; const[esales_rate_er,setesales_rate_er]=useState();
//eservice_cost
const[eservice_cost,seteservice_cost]=useState();const updateeservice_cost = (event) => { seteservice_cost(event.target.value);}; const[eservice_cost_er,seteservice_cost_er]=useState();
//ediscount_per
const[ediscount_per,setediscount_per]=useState();const updateediscount_per = (event) => { setediscount_per(event.target.value);}; const[ediscount_per_er,setediscount_per_er]=useState();


//Edit Function
function getservicedatabyId(){
 

  const serviceid=sessionStorage.getItem("Serviceid00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&(busyid>0)&&(counterid>0)&&(serviceid>0)){
 
 
 axios.post("bt-serviceitem-details-byid", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Service_id:serviceid,

 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");
     sessionStorage.removeItem("Serviceid00");


     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){

   //Setting Data
   seteservice_name(response.data.service_name);
   seteservice_code(response.data.service_code);
   seteservice_type(response.data.type);
   seteservice_category(response.data.category);
   seteservice_status(response.data.status);
   setedescription(response.data.description);
   setesales_rate(response.data.sales_rate);
   seteservice_cost(response.data.service_cost);
   setediscount_per(response.data.discount_per);
    
  }
  //Cannot Fetch Data
  else{


      document.getElementById("edit-form").style.display="none";

     //Setting Variables to empty 
     seteservice_name_er(" ");seteservice_code_er(" ");seteservice_type_er(" ");seteservice_category_er(" ");seteservice_status_er();setedescription_er();seterror_msg(" ");
     setesales_rate_er(" ");seteservice_cost_er(" ");setediscount_per_er(" ");
     seteservice_name(" ");seteservice_code(" ");seteservice_type(" ");seteservice_category(" ");seteservice_status();setedescription();
     setesales_rate(" ");seteservice_cost(" ");setediscount_per(" ");

      document.getElementById("edit-error-card").style.display="block"; 
      sessionStorage.removeItem("Serviceid00");
  }
 
 
 });
 
 }
 //User not Logedin
 else{

     //Checking if user loggedin
     if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))){
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
     }
 
  }
 
 }
  
 //******************* GET SERVICE ITEM DATA BY ID FUNCTION END  ********************//


 

 //******************* EDIT SERVICE ITEM FUNCTION START ********************//
function editservice(){

  //Setting Error Variables
  seteservice_name_er(" ");seteservice_code_er(" ");seteservice_type_er(" ");seteservice_category_er(" ");seteservice_status_er();setedescription_er();
  setesales_rate_er(" ");seteservice_cost_er(" ");setediscount_per_er(" ");seterror_msg(" ");

  const serviceid = sessionStorage.getItem("Serviceid00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((busyid!=null)||(busyid!=" "))&&((counterid!=null)||(counterid!=" "))&&((serviceid!=null)||(serviceid!=" "))){
 
 
  axios.post("bt-serviceitem-edit", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Service_id:serviceid,
   Service_name :eservice_name,
   Service_code :eservice_code,
   Type:eservice_type,
   Category : eservice_category,
   Status:eservice_status,
   Description:edescription,
   Sales_rate:esales_rate,
   Service_cost:eservice_cost,
   Discount_per:ediscount_per,


 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");
     sessionStorage.removeItem("Productid00");

     window.location.replace("businesstools-login");
  }

   //Validation Errors
 if(response.data.validatorerror){
  seteservice_name_er(response.data.validatorerror.Service_name);
  seteservice_code_er(response.data.validatorerror.Service_code);
  seteservice_type_er(response.data.validatorerror.Type);
  seteservice_category_er(response.data.validatorerror.Category);
  seteservice_status_er(response.data.validatorerror.Status);
  setedescription_er(response.data.validatorerror.Description);
  setesales_rate_er(response.data.validatorerror.Sales_rate);
  seteservice_cost_er(response.data.validatorerror.Service_cost);
  setediscount_per_er(response.data.validatorerror.Discount_per);
  seterror_msg("Cannot Update Service Item!"); 
}
//Invalid Entries
if(response.data.error==102){ 
  
  seteservice_name_er(response.data.service_name_er);
  seteservice_code_er(response.data.validatorerror.service_code);
  seteservice_type_er(response.data.type_er);
  seteservice_category_er(response.data.category_er);
  seteservice_status_er(response.data.status_er);
  setedescription_er(response.data.description_er);
  setesales_rate_er(response.data.sales_rate_er);
  seteservice_cost_er(response.data.service_cost_er);
  setediscount_per_er(response.data.discount_per_er);
  seterror_msg("Cannot Update Service Item!");  
}


  //Invalid Entries
  if(response.data.error==103){     seterror_msg(response.data.error_msg);  }

   //Transaction Updated Successfully
   if(response.data.successvar==1){        
     //Setting Variables to empty 
     seteservice_name_er(" ");seteservice_code_er(" ");seteservice_type_er(" ");seteservice_category_er(" ");seteservice_status_er();setedescription_er();seterror_msg(" ");
     setesales_rate_er(" ");seteservice_cost_er(" ");setediscount_per_er(" ");
     seteservice_name(" ");seteservice_code(" ");seteservice_type(" ");seteservice_category(" ");seteservice_status();setedescription();
     setesales_rate(" ");seteservice_cost(" ");setediscount_per(" ");
     document.getElementById("edit-form").style.display="none"; 
    document.getElementById("edit-success-card").style.display="block";  }

   //Cannot Update Transaction
   else{  seterror_msg("Cannot Update Service Item !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   sessionStorage.removeItem("Productid00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* EDIT SERVICE ITEM FUNCTION END ********************//




  
   
//******************* DELETE SERVICE ITEM FUNCTION START ********************//
function deleteservice(){

  const serviceId=sessionStorage.getItem("DServiceId00");

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((busyid!=null)||(busyid!=" "))&&((counterid!=null)||(counterid!=" "))&&((serviceId!=null)||(serviceId!=" "))){
 
 axios.post("bt-serviceitem-delete", {
   Busy_id:busyid,
   Counter_id:counterid,
   Log_id:logid,
   Token:token,
   Service_id:serviceId
 })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");
     sessionStorage.removeItem("DServiceId00");


     window.location.replace("businesstools-login");
  }

  //Counter Deleted Successfully
   if(response.data.successvar==1){        

      document.getElementById("delete-card").style.display="none";
      document.getElementById("delete-success-card").style.display="block";  
      sessionStorage.removeItem("DServiceId");

  }
  
      //Cannot Delete Counter
    else{  
    document.getElementById("delete-card").style.display="none";
    document.getElementById("delete-error-card").style.display="block";   }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   sessionStorage.removeItem("DServiceId00");


   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* DELETE SERVICE ITEM FUNCTION END ********************//



return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>Business Tools|BookKeeping Solution</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div class="container-scroller">

      <Sidebar />
    <div class="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div class="main-panel">

   
          {/* ADD SERVICE SUCCESS CARD START */}
          <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">New Service Item Added Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <a href="businesstools-user-services"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD SERVICE SUCCESS CARD END */}

                 {/* ADD SERVICE EDIT SUCCESS CARD START */}
             <div class="d-flex justify-content-center">
             <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Service Item Updated Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("edit-success-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD SERVICE EDIT SUCCESS CARD END */}
               {/* ADD SERVICE EDIT ERROR CARD START */}
            <div class="d-flex justify-content-center">
            <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-error-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Cannot Fetch Data !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("edit-error-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD SERVICE EDIT ERROR CARD END */}

                    {/* ADD SERVICE DELETE CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="delete-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Are you sure you want to delete this transaction?</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> This action cannot be reversed. You will lose all your data related to this transaction if you wish to continue this action.</p>
                      <button class="mt-3 btn btn-outline-success" onClick={deleteservice}>Yes, I Know! Delete Transaction.</button>
                      <button class="mt-3 btn btn-outline-danger" style={{marginLeft:"1rem"}} onClick={()=>{  
                      //Cancel Delete and remove Product_id
                      sessionStorage.removeItem("DServiceId00"); document.getElementById('delete-card').style.display = 'none'; }}>No, Don't Delete Transaction.</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD SERVICE DELETE CARD END */}
              {/* ADD SERVICE DELETE SUCCESS CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="delete-success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Service Item Deleted Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("delete-success-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD SERVICE DELETE SUCCESS CARD END */}
               {/*  ADD SERVICE DELETE ERROR CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="delete-error-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Cannot Delete Service Item !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("delete-error-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD SERVICE DELETE ERROR CARD END */}



          <div class="content-wrapper pb-0">

          <div class="row">
              <div class="col-12 grid-margin create-form" id="create-form">
              <Add_service />
              </div>
          </div>

            <div class="page-header flex-wrap">
            <div class="header-left"></div>
              <div class="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pe-3">Services</p>
                  </a>
                  <a class="ps-3 me-4" href="#">
                  {/*}  <p class="m-0">ADE-00234</p> */}
                  </a>
                </div>
              
                <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text" onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i class="mdi mdi-plus-circle"></i> New Service </button>
              </div>
            </div>

            {/*} chart row starts here */}
         {/*}   <div class="row">
              <div class="col-sm-6 stretch-card grid-margin">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div class="card-title">
                      </div>
                      <div class="d-flex text-muted font-20">
                        <i class="mdi mdi-printer mouse-pointer"></i>
                        <i class="mdi mdi-help-circle-outline ms-2 mouse-pointer"></i>
                      </div>
                    </div>
                    <h3 class="font-weight-bold mb-0"> 2,409 <span class="text-success h5">4,5%<i class="mdi mdi-arrow-up"></i></span>
                    </h3>
                    <span class="text-muted font-13">Catalog Items/Day</span>
                    <div class="line-chart-wrapper">
                      <canvas id="linechart" height="80"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 stretch-card grid-margin">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div class="card-title"> Conversions
                      </div>
                      <div class="d-flex text-muted font-20">
                        <i class="mdi mdi-printer mouse-pointer"></i>
                        <i class="mdi mdi-help-circle-outline ms-2 mouse-pointer"></i>
                      </div>
                    </div>
                    <h3 class="font-weight-bold mb-0"> 0.40% <span class="text-success h5">0.20%<i class="mdi mdi-arrow-up"></i></span>
                    </h3>
                    <span class="text-muted font-13">Catalog Groups/Day</span>
                    <div class="bar-chart-wrapper">
                      <canvas id="barchart" height="80"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

             {/* SERVICE ITEM EDIT FORM START */}
             <div class="row">
              <div class="col-12 grid-margin create-form" id="edit-form" style={{display:"none"}}>
              <div class="card">
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ 
                         //close edit form button
                         document.getElementById("edit-form").style.display="none";
                        //Setting Variables to empty
                        //Setting Variables to empty 
                        seteservice_name_er(" ");seteservice_code_er(" ");seteservice_type_er(" ");seteservice_category_er(" ");seteservice_status_er();setedescription_er();
                        setesales_rate_er(" ");seteservice_cost_er(" ");setediscount_per_er(" ");seterror_msg(" ");
                        seteservice_name(" ");seteservice_code(" ");seteservice_type(" ");seteservice_category(" ");seteservice_status();setedescription();
                        setesales_rate(" ");seteservice_cost(" ");setediscount_per(" ");
    
                        sessionStorage.removeItem("Productid00");}}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Edit Service</h4>
                    <div class="form-sample">
                      <p class="card-description">edit your service details here</p>
                      <code>{error_msg}</code>
                      <div class="row">
                       <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Service Code</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="SER00001" id="eservice_code" value={eservice_code} onChange={updateeservice_code} />
                            <code>{eservice_code_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Service Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Service Name" id="eservice_name" value={eservice_name} />
                              <p class="text-muted" style={{fontSize:"0.7rem", textAlign:"left"}}>this field cannot be changed</p>
                            <code>{eservice_name_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">            
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                            <input type="text" class="form-control" placeholder="Type Regular" id="eservice_type" value={eservice_type} onChange={updateeservice_type}/>
                            <code>{eservice_type_er}</code>
                            </div>
                          </div>
                        </div>  
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Category</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Category" id="eservice_category" value={eservice_category} onChange={updateeservice_category} />
                            <code>{eservice_category_er}</code>
                            </div>
                          </div>
                        </div> 
                        </div>    
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Sales Rate</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="2000.00" id="esales_rate" value={esales_rate} onChange={updateesales_rate}/>
                              <code>{esales_rate_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Service Cost</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="1500.00" id="eservice_cost" value={eservice_cost} onChange={updateeservice_cost} />
                            <code>{eservice_cost_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Discount %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="10.00" id="ediscount_per" value={ediscount_per} onChange={updateediscount_per} />
                              <code>{ediscount_per_er}</code>
                            </div>
                          </div>
                        </div>     
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Status</label>
                            <div class="col-sm-9">
                            <select class="form-control" id="eservice_status" style={{padding:"1rem"}} value={eservice_status} onChange={updateeservice_status} >
                              <option value={eservice_status}>{eservice_status}</option>
                              <option value="active">active</option>
                              <option value="inactive">inactive</option>
                              </select>
                              <code>{eservice_status_er}</code>
                            </div>
                          </div>
                        </div>                  
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Description</label>
                        <textarea class="form-control" rows="2" id="edescription" value={edescription} onChange={updateedescription} ></textarea>
                       <code>{edescription_er}</code>
                      </div>

                        
                      
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={editservice}>Edit Service</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>
              </div>
              </div>
               {/* SERVICE ITEM EDIT FORM END */}
                  
                  {/* SERVICES ITEM LIST START */}
             <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Services</h4>
                    <p class="card-description">view services here
                    </p>

                 {/* FILTER SECTION START */}
                 <hr/>
                            <div id="filter-top-card" class="row col-12" style={{textAlign:"left",display:"none"}}>
                            <div class="d-flex justify-content-between">
                            <div>
                            <h4 style={{padding:'1rem'}}>Filters</h4>
                           </div>
                           <div>
                    
                           <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card").style.display="none"; }}>
                           <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                           </button>
                           </div>
                           </div>
        
                        <div class="row">
                     {/*}  <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Product Id</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" id="filter_product_id" placeholder="457" value={filter_product_id} onChange={updatefilter_product_id}  />
                              <code>{filter_product_id_er}</code> 
                            </div>
                          </div>
                        </div> */}
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Service Code</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control"  id="filter_service_code" placeholder="PC123" value={filter_service_code} onChange={updatefilter_service_code}  />
                              <code>{filter_service_code_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Service Name</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" id="filter_service_name" placeholder="Service Name" value={filter_service_name} onChange={updatefilter_service_name}  />
                              <code>{filter_service_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Type</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control"  id="filter_type" placeholder="Regular" value={filter_type} onChange={updatefilter_type}  />
                              <code>{filter_type_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Category</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="Most Sold"   id="filter_category" value={filter_category} onChange={updatefilter_category}  />
                              <code>{filter_category_er}</code>
                            </div>
                          </div>
                        </div>
                  
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Sales Rate</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="500.00"   id="filter_sales_rate" value={filter_sales_rate} onChange={updatefilter_sales_rate}  />
                              <code>{filter_sales_rate_er}</code>
                            </div>
                          </div>
                        </div>
                
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Service Cost</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="200.00"   id="filter_service_cost" value={filter_service_cost} onChange={updatefilter_service_cost}  />
                              <code>{filter_service_cost_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Service Status</label>
                            <div class="col-sm-8">
                              <select class="form-control" style={{padding:"1rem"}} placeholder="Highly Rated" id="filter_service_status" value={filter_service_status} onChange={updatefilter_service_status}>
                              <option value=" ">Select Status</option>
                              <option value="active">active</option>
                              <option value="inactive">inactive</option>
                              </select>
                              <code>{filter_service_status_er}</code>
                            </div>
                          </div>
                          </div>
                        <div class="col-md-4">
                          
                        <button class="btn btn-primary" onClick={()=>{ setfilter_val(1); getData(); }}>Apply Filters</button>
                         <button class="btn btn-danger" style={{marginLeft:"1rem"}} onClick={()=>{ setfilter_val(0); getData(); }}>Remove Filters</button>
                       
                        </div>
                      </div>

                      <div style={{marginBottom:"1rem"}}>
                  
                       
                      </div>
                            <hr/>                      
                            </div>
                            
                            {/* FILTER SECTION END */}

                    <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                        {/* COLUMNS MANAGEMENT DROPDOWN START */}
                          <div class="dropdown">
                          <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>
                            <button class="btn btn-primary dropdown-toggle" style={{marginLeft:"1rem"}} type="button" id="dropdownMenuIconButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="mdi mdi-table-large"></i>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton1">
                              <h6 class="dropdown-header">Columns</h6>
                              <hr/>
                              
                              {/* Column 1 */}
                              <li><div class="d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Sn</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c1_yes" onClick={()=>{setcd_col1_val(1); document.getElementById("cd_c1_yes").style.display="none"; document.getElementById("cd_c1_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c1_no" style={{ display:"none"}} onClick={()=>{ setcd_col1_val(0); document.getElementById("cd_c1_yes").style.display="block"; document.getElementById("cd_c1_no").style.display="none"; }}></i>
                              </div></div></li> 
                               {/* Column 2 
                               <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Product Id</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c2_yes"  onClick={()=>{setcd_col2_val(1); document.getElementById("cd_c2_yes").style.display="none"; document.getElementById("cd_c2_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c2_no" style={{ display:"none"}} onClick={()=>{ setcd_col2_val(0); document.getElementById("cd_c2_yes").style.display="block"; document.getElementById("cd_c2_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 3 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Service Code</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c3_yes"  onClick={()=>{setcd_col3_val(1); document.getElementById("cd_c3_yes").style.display="none"; document.getElementById("cd_c3_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c3_no" style={{ display:"none"}} onClick={()=>{ setcd_col3_val(0); document.getElementById("cd_c3_yes").style.display="block"; document.getElementById("cd_c3_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 4 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Product HSN</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c4_yes"  onClick={()=>{setcd_col4_val(1); document.getElementById("cd_c4_yes").style.display="none"; document.getElementById("cd_c4_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c4_no" style={{ display:"none"}} onClick={()=>{ setcd_col4_val(0); document.getElementById("cd_c4_yes").style.display="block"; document.getElementById("cd_c4_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 5 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Service Name</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c5_yes"  onClick={()=>{setcd_col5_val(1); document.getElementById("cd_c5_yes").style.display="none"; document.getElementById("cd_c5_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c5_no" style={{ display:"none"}} onClick={()=>{ setcd_col5_val(0); document.getElementById("cd_c5_yes").style.display="block"; document.getElementById("cd_c5_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 6 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Type</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c6_yes"  onClick={()=>{setcd_col6_val(1); document.getElementById("cd_c6_yes").style.display="none"; document.getElementById("cd_c6_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c6_no" style={{ display:"none"}} onClick={()=>{ setcd_col6_val(0); document.getElementById("cd_c6_yes").style.display="block"; document.getElementById("cd_c6_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 7 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Category</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c7_yes" onClick={()=>{setcd_col7_val(1); document.getElementById("cd_c7_yes").style.display="none"; document.getElementById("cd_c7_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c7_no" style={{ display:"none"}} onClick={()=>{ setcd_col7_val(0); document.getElementById("cd_c7_yes").style.display="block"; document.getElementById("cd_c7_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 8 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Brand</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c8_yes" onClick={()=>{setcd_col8_val(1); document.getElementById("cd_c8_yes").style.display="none"; document.getElementById("cd_c8_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c8_no" style={{ display:"none"}} onClick={()=>{ setcd_col8_val(0); document.getElementById("cd_c8_yes").style.display="block"; document.getElementById("cd_c8_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 9 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Group</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c9_yes" onClick={()=>{setcd_col9_val(1); document.getElementById("cd_c9_yes").style.display="none"; document.getElementById("cd_c9_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c9_no" style={{ display:"none"}} onClick={()=>{ setcd_col9_val(0); document.getElementById("cd_c9_yes").style.display="block"; document.getElementById("cd_c9_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 10 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Description</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c10_yes" onClick={()=>{setcd_col10_val(1); document.getElementById("cd_c10_yes").style.display="none"; document.getElementById("cd_c10_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c10_no" style={{ display:"none"}} onClick={()=>{ setcd_col10_val(0); document.getElementById("cd_c10_yes").style.display="block"; document.getElementById("cd_c10_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 11 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Sales Rate</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c11_yes" onClick={()=>{setcd_col11_val(1); document.getElementById("cd_c11_yes").style.display="none"; document.getElementById("cd_c11_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c11_no" style={{ display:"none"}} onClick={()=>{ setcd_col11_val(0); document.getElementById("cd_c11_yes").style.display="block"; document.getElementById("cd_c11_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 12 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Service Cost</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c12_yes" onClick={()=>{setcd_col12_val(1); document.getElementById("cd_c12_yes").style.display="none"; document.getElementById("cd_c12_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c12_no" style={{ display:"none"}} onClick={()=>{ setcd_col12_val(0); document.getElementById("cd_c12_yes").style.display="block"; document.getElementById("cd_c12_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 13 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Units</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c13_yes" onClick={()=>{setcd_col13_val(1); document.getElementById("cd_c13_yes").style.display="none"; document.getElementById("cd_c13_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c13_no" style={{ display:"none"}} onClick={()=>{ setcd_col13_val(0); document.getElementById("cd_c13_yes").style.display="block"; document.getElementById("cd_c13_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 14 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Discount %</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c14_yes" onClick={()=>{setcd_col14_val(1); document.getElementById("cd_c14_yes").style.display="none"; document.getElementById("cd_c14_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c14_no" style={{ display:"none"}} onClick={()=>{ setcd_col14_val(0); document.getElementById("cd_c14_yes").style.display="block"; document.getElementById("cd_c14_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 15 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Sgst %</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c15_yes" onClick={()=>{setcd_col15_val(1); document.getElementById("cd_c15_yes").style.display="none"; document.getElementById("cd_c15_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c15_no" style={{ display:"none"}} onClick={()=>{ setcd_col15_val(0); document.getElementById("cd_c15_yes").style.display="block"; document.getElementById("cd_c15_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 16 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Cgst %</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c16_yes" onClick={()=>{setcd_col16_val(1); document.getElementById("cd_c16_yes").style.display="none"; document.getElementById("cd_c16_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c16_no" style={{ display:"none"}} onClick={()=>{ setcd_col16_val(0); document.getElementById("cd_c16_yes").style.display="block"; document.getElementById("cd_c16_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 17 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Igst %</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c17_yes" onClick={()=>{setcd_col17_val(1); document.getElementById("cd_c17_yes").style.display="none"; document.getElementById("cd_c17_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c17_no" style={{ display:"none"}} onClick={()=>{ setcd_col17_val(0); document.getElementById("cd_c17_yes").style.display="block"; document.getElementById("cd_c17_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 18 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Tax %</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c18_yes" onClick={()=>{setcd_col18_val(1); document.getElementById("cd_c18_yes").style.display="none"; document.getElementById("cd_c18_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c18_no" style={{ display:"none"}} onClick={()=>{ setcd_col18_val(0); document.getElementById("cd_c18_yes").style.display="block"; document.getElementById("cd_c18_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 19 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Status</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c19_yes" onClick={()=>{setcd_col19_val(1); document.getElementById("cd_c19_yes").style.display="none"; document.getElementById("cd_c19_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c19_no" style={{ display:"none"}} onClick={()=>{ setcd_col19_val(0); document.getElementById("cd_c19_yes").style.display="block"; document.getElementById("cd_c19_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 20 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Updated By</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c20_yes" onClick={()=>{setcd_col20_val(1); document.getElementById("cd_c20_yes").style.display="none"; document.getElementById("cd_c20_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c20_no" style={{ display:"none"}} onClick={()=>{ setcd_col20_val(0); document.getElementById("cd_c20_yes").style.display="block"; document.getElementById("cd_c20_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 21 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Updated At</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c21_yes" onClick={()=>{setcd_col21_val(1); document.getElementById("cd_c21_yes").style.display="none"; document.getElementById("cd_c21_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c21_no" style={{ display:"none"}} onClick={()=>{ setcd_col21_val(0); document.getElementById("cd_c21_yes").style.display="block"; document.getElementById("cd_c21_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 24 
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">QR Code</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c24_yes" style={{ display:"none"}} onClick={()=>{setcd_col24_val(1); document.getElementById("cd_c24_yes").style.display="none"; document.getElementById("cd_c24_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c24_no"  onClick={()=>{ setcd_col24_val(0); document.getElementById("cd_c24_yes").style.display="block"; document.getElementById("cd_c24_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 22 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10 text-warning">Edit</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c22_yes" onClick={()=>{setcd_col22_val(1); document.getElementById("cd_c22_yes").style.display="none"; document.getElementById("cd_c22_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c22_no" style={{ display:"none"}} onClick={()=>{ setcd_col22_val(0); document.getElementById("cd_c22_yes").style.display="block"; document.getElementById("cd_c22_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 23 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10 text-danger">Delete</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c23_yes"  onClick={()=>{setcd_col23_val(1); document.getElementById("cd_c23_yes").style.display="none"; document.getElementById("cd_c23_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c23_no" style={{ display:"none"}} onClick={()=>{ setcd_col23_val(0); document.getElementById("cd_c23_yes").style.display="block"; document.getElementById("cd_c23_no").style.display="none"; }}></i>
                              </div></div></li> 
                            {/*}  <div class="dropdown-divider"></div>
                              <button class="btn btn-danger">Close</button>*/}
                            </div> 
                          </div>
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>


                    <div class="table-responsive" id="reports" ref={componentRef}>
                      <table class="table table-hover">
                        <thead>
                          <tr >
                            <th  style={{fontWeight:"bold"}} hidden={cd_col1_val==1} >Sn</th>
                         {/*}   <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >Product Id</th> */}
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1} >Service Code</th>
                         {/*}   <th  style={{fontWeight:"bold"}} hidden={cd_col4_val==1} >Product HSN</th> */}
                            <th  style={{fontWeight:"bold"}} hidden={cd_col5_val==1} >Service Name</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col6_val==1} >Type</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col7_val==1} >Category</th>
                           {/*} <th  style={{fontWeight:"bold"}} hidden={cd_col8_val==1} >Brand</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col9_val==1} >Group</th> */}
                            <th  style={{fontWeight:"bold"}} hidden={cd_col10_val==1} >Description</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col11_val==1} >Sales Rate</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col12_val==1} >Service Cost</th>
                          {/*}  <th  style={{fontWeight:"bold"}} hidden={cd_col13_val==1} >Units</th> */}
                            <th  style={{fontWeight:"bold"}} hidden={cd_col14_val==1} >Discount %</th>
                          {/*}  <th  style={{fontWeight:"bold"}} hidden={cd_col15_val==1} >SGST %</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col16_val==1} >CGST %</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col17_val==1} >IGST %</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col18_val==1} >Tax %</th>*/}
                            <th  style={{fontWeight:"bold"}} hidden={cd_col19_val==1} >Status</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col20_val==1} >Updated By</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col21_val==1} >Updated At</th>
                          {/*}  <th  style={{fontWeight:"bold"}} hidden={cd_col24_val==1} ></th>*/}
                            <th  style={{fontWeight:"bold"}} hidden={cd_col22_val==1} ></th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col23_val==1} ></th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                       services.map((curElm2,ind)=>{

                         return(
                         <>
                        <tr key={curElm2.Service_id}>
                            <td hidden={cd_col1_val==1} >{curElm2.Sn}</td>
                         {/*}   <td hidden={cd_col2_val==1} >{curElm2.Product_id}</td> */}
                            <td hidden={cd_col3_val==1} >{curElm2.Service_code}</td>
                          {/*}  <td hidden={cd_col4_val==1} >{curElm2.Service_hsn}</td>*/}
                            <td hidden={cd_col5_val==1} >{curElm2.Service_name}</td>
                            <td hidden={cd_col6_val==1} >{curElm2.Type}</td>
                            <td hidden={cd_col7_val==1} >{curElm2.Category}</td>
                           {/*} <td hidden={cd_col8_val==1} >{curElm2.Brand}</td>
                            <td hidden={cd_col9_val==1} >{curElm2.Group_name}</td> */}
                            <td hidden={cd_col10_val==1} >{curElm2.Description}</td>
                            <td hidden={cd_col11_val==1} >{curElm2.Sales_rate}</td>
                            <td hidden={cd_col12_val==1} >{curElm2.Service_cost}</td>
                           {/*} <td hidden={cd_col13_val==1} >{curElm2.Units}</td> */}
                            <td hidden={cd_col14_val==1} >{curElm2.Discount_per}</td>
                           {/*} <td hidden={cd_col15_val==1} >{curElm2.Sgst_per}</td>
                            <td hidden={cd_col16_val==1} >{curElm2.Cgst_per}</td>
                            <td hidden={cd_col17_val==1} >{curElm2.Igst_per}</td>
                            <td hidden={cd_col18_val==1} >{curElm2.Tax_per}</td> */}
                            <td hidden={cd_col19_val==1} ><label class="badge badge-success"  hidden={(curElm2.Service_status == "inactive")}>active</label><label class="badge badge-danger"  hidden={(curElm2.Service_status == "active")}>inactive</label></td>
                            <td hidden={cd_col20_val==1} >{curElm2.Updated_by}</td>
                            <td hidden={cd_col21_val==1} >{curElm2.Date_updated} ({curElm2.Time_updated})</td>
                           {/*  <td hidden={cd_col24_val==1} >  
                            QR CODE 
                            <div id="QR" ref={componentRef2}>
                            <QRCodeCanvas 
                            value={JSON.stringify({
                            Sn: curElm2.Sn,
                            Product_id: curElm2.Product_id,
                            Product_code: curElm2.Product_code,
                            Product_hsn: curElm2.Product_hsn,
                            Product_name: curElm2.Product_name,
                            Type: curElm2.Type,
                            Category: curElm2.Category,
                            Brand: curElm2.Brand,
                            Group_name: curElm2.Group_name,
                            Description: curElm2.Description,
                            Sales_rate: curElm2.Sales_rate,
                            Purchase_rate: curElm2.Purchase_rate,
                            Units: curElm2.Units,
                            Discount_per: curElm2.Discount_per,
                            Sgst_per: curElm2.Sgst_per,
                            Cgst_per: curElm2.Cgst_per,
                            Igst_per: curElm2.Igst_per,
                            Tax_per: curElm2.Tax_per,
                            Product_status: curElm2.Product_status,
                            Updated_by: curElm2.Updated_by,
                            Date_updated: curElm2.Date_updated,
                            Time_updated: curElm2.Time_updated
                            })} 
                            />
                            </div>
                             <br/><br/>
                             <button class="btn btn-light" onClick={handlePrint2}>download</button>
                            </td> */}


                            <td hidden={cd_col22_val==1} ><i class="mdi mdi-pencil-box text-warning" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                            //Setting Bank Id and Redirect to Edit
                            sessionStorage.setItem("Serviceid00",curElm2.Service_id);getservicedatabyId();document.getElementById('edit-form').style.display = 'block'; }}></i></td>
                            <td hidden={cd_col23_val==1} ><i class="mdi mdi-delete-forever text-danger" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                            //Setting Bank Id for Delete
                            sessionStorage.setItem("DServiceId00",curElm2.Service_id); document.getElementById('delete-card').style.display = 'block'; }}></i></td>
                          </tr>
                          </>
                         )
                         }
					   
	                  		 )
                         }
                        
                        </tbody>
                      </table>
                    </div>
                       {/* PAGINATION SECTION START */}
                       <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}

                    <button class="btn btn-light" onClick={handlePrint}><i class="mdi mdi-cloud-print text-dark"></i></button>
                    <button class="btn btn-light" onClick={downloadExcel}><i class="mdi mdi-file-excel text-dark"></i></button>
                    
                  </div>
                </div>
              </div>
              {/* PRODUCTS ITEM LIST END */}

            
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

}
}
export default Userservices;